<template>
    <div class="pa-2">
        <!-- delete dialog -->
        <v-delete-dialog
			v-model="deleteDialog"
			:module="'computerSkills/delete'"
			:parameters="{ id: itemId ? itemId : null }"
			@on-delete="getAll()">
			{{ $T('ComputerSkills.delete-message') }}
		</v-delete-dialog>

        <!-- dialog -->
        <v-dialog
			v-model="dialog"
			max-width="400px"
			transition="dialog-transition"
        >
			<v-card>
				<v-card-title primary-title>
                    {{  $T('ComputerSkills.add-skill')  }}
					<v-spacer></v-spacer>
					<v-btn
						@click="dialog = false"
						icon>
						<v-icon color="alert-color">mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-row dense>
						<v-col cols="12">
							<v-text-field
								v-model="name"
								outlined
								dense
								label="الاسم"
								hide-details></v-text-field>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions class="align-center">
					<v-spacer></v-spacer>
					<v-btn
						color="secondary"
						:disabled="loadingAdding || !name"
						:loading="loadingAdding"
						@click="addOrEdit()">
						{{ $T('default-buttons.save') }}
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
        <v-row>
            <v-spacer />
            <v-col cols="auto">
				<v-btn
					@click="dialog = true"
					small
					color="primary">
					<v-icon left> $add </v-icon>
					{{ $T('add') }}
				</v-btn>
			</v-col>
        </v-row>
        <bee-handy-table 
            :headers="headers"
            :items="computerSkills"
            dense
            zebra
            :items-per-page="-1"
            hide-default-footer
            class="mt-2"
        >
            <template v-slot:item.actions="{ item }">
                <div class="d-flex justify-end">
                    <tooltip :text="$T('tooltips.edit')">
                        <v-btn
                            depressed
                            rounded
                            icon
                            small
                            @click="itemId = item.id; dialog = true"
                            >
                            <v-icon
                                size="20"
                                color="edit-color">
                                $edit
                            </v-icon>
                        </v-btn>
                    </tooltip>

                    <tooltip :text="$T('tooltips.delete')">
                        <v-btn
                            depressed
                            rounded
                            icon
                            small
                            @click="itemId = item.id; deleteDialog = true"
                            >
                            <v-icon
                                size="20"
                                color="alert-color  ">
                                $delete
                            </v-icon>
                        </v-btn>
                    </tooltip>
                </div>
            </template>
        </bee-handy-table>
    </div>
</template>

<script>
export default {
    watch: {
        dialog(val) {
            if(val && this.itemId !== null) {
                this.name = this.computerSkills.find(c => c.id === this.itemId)?.name
            } else {
                this.name = null 
                this.itemId = null
            }
        }
    },
    data () {
        return {
            loading: false,
            loadingAdding: false,
            itemId: null,
            deleteDialog: false,
            headers: [
                {
                    text: this.$T('ComputerSkills.headers.skill'),
                    name: 'name',
                    value: 'name'
                },
                {
                    text: '',
                    name: 'actions',
                    value: 'actions'
                }
            ],
            computerSkills: [],
            dialog: false,
            name: null
        }
    },

    methods: {
        addOrEdit() {
            this.submitloading = true
            const actionName = this.itemId ? 'update' : 'create'
            this.$store.dispatch(`computerSkills/${actionName}`, { name: this.name, id: this.itemId }).then(() => {
                this.getAll()
            }).finally(() => {
                this.submitloading = false
                this.itemId = null
                this.dialog = false
            })
        },

        getAll() {
            this.loading = true
            return this.$store.dispatch('computerSkills/fetchAll').then((data) => {
            this.computerSkills = data
            }).finally(() => {
                this.loading = false
            })
        }
    },

    created() {
        this.loading = true
        this.$store.dispatch('computerSkills/fetchAll').then((data) => {
            this.computerSkills = data
        }).finally(() => {
            this.loading = false
        })
    }
}
</script>
